
<template>
  <v-form ref="form" lazy-validation :readonly="read_only">
    <v-radio-group v-model="type" row :rules="required">
      <v-radio color="blue darken-4" label="Pessoa Física" value="Pessoa Física"></v-radio>
      <v-radio color="red darken-4" label="Pessoa Jurídica" value="Pessoa Jurídica"></v-radio>
    </v-radio-group>
    <div v-if="type == 'Pessoa Jurídica'">
      <ClientPJ ref="client_pj" :creating="creating" :set_client="client" :type="type"></ClientPJ>
    </div>
    <div v-if="type == 'Pessoa Física'">
      <ClientPF ref="client_pf" :set_client="client" :type="type"></ClientPF>
    </div>
    <v-select 
      v-if="!creating"
      :items="categories" :rules="[...required]" 
      item-text="text" 
      item-value="value" 
      v-model="client.category" 
      label="Segmento" 
      prepend-icon="mdi-briefcase"
    ></v-select>
  </v-form>
</template>

<script>
import validations from "@/mixins/validations.js"

export default {
  name: 'ClientInfoForm',
  mixins:[ validations ],
  components: {
    ClientPJ: () => import("./ClientPJ.vue"),
    ClientPF: () => import("./ClientPF.vue"),
  },
  props:{
    client:{
      type: Object,
      default: () => { return {} }
    },
    read_only:{
      type: Boolean,
      default: false,
    },
    creating:{
      type: Boolean,
      default: false
    }
    
  },
  data() {
    return {
      type: 'Pessoa Física',
      categories: [
        {
          text: 'Não classificado',
          value: 'not_classified',
        },
        {
          text: 'Revenda',
          value: 'resale',
        },
        {
          text: 'Construtora',
          value: 'construction',
        },
        {
          text: 'Indústria de blocos e artefatos',
          value: 'industry',
        },
        {
          text: 'Consumidor Final',
          value: 'final_costumer',
        },
      ],
    }
  },
  computed:{
    type_computed(){
      return this.type
    }
  },
  methods: {
    validate(){
      // VALIDA O FORMULARIO, VERIFICA SE É PF OU PJ E PEGA O PELO REF O CHILDREN E ENVIA O VALOR PARA O PAI
      
      if (this.type == 'Pessoa Física') {
        this.client.corporateName = this.$refs?.client_pf?.client.name
        this.client.CNPJ = this.$route.params.id ? this.client.CNPJ : '' ///SE TEM ID PARA MANTER O MESMO VALOR SALVO POR CAUSA DO VALIDATE
        this.client.fantasyName = ''
        this.client.name = this.$refs.client_pf?.client.name
        this.client.CPF = this.$refs.client_pf?.client.CPF
      } else if (this.type == 'Pessoa Jurídica') {
        this.client.corporateName = this.$refs.client_pj?.client.corporateName
        this.client.CNPJ = this.$refs.client_pj?.client.CNPJ
        this.client.fantasyName = this.$refs.client_pj?.client.fantasyName
        this.client.name = this.$refs.client_pj?.client.corporateName
        this.client.CPF = this.$route.params.id ? this.client.CPF : ''  ///SE TEM ID PARA MANTER O MESMO VALOR SALVO POR CAUSA DO VALIDATE
      }
      return this.$refs.form.validate()
    },
    setJuridicPerson(){
      this.type = 'Pessoa Jurídica'
    },
    setCPFPerson(){
      this.type = 'Pessoa Física'
    },
    setClient(){
      // VERIFICA SE É CNPJ E SETA NO COMPONENTE PELO REFS.
      if(this.$route.params.id){
        if(this.client.CNPJ.length >= 14){
          this.setJuridicPerson()
        }else{
          this.setCPFPerson()
        }
      }
    },
  },
  watch:{
    type(){
      if (this.type == 'Pessoa Física') {
        this.setCPFPerson()
      } else if (this.type == 'Pessoa Jurídica') {
        this.setJuridicPerson()
      }
    }
  },
  mounted(){
    this.setClient()
  }

}
</script>